

<div class="login-body">
  <div class="login-card text-bg-success">
  <div class="brand-logo">
    <span class="brand-name">Betfair<span>9x</span></span>
  </div>
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Username" formControlName="userName"
        [ngClass]="{'is-invalid': (submitted || f.userName.touched) && f.userName.errors}" />
      <span class="input-icon"><i class="bi bi-person-fill"></i></span>
      <div *ngIf="(submitted || f.userName.touched) && f.userName.errors" class="invalid-feedback">
        <div *ngIf="f.userName.errors.required">Username is required</div>
      </div>
      <!-- <small>Please enter username</small> -->
    </div>
    <div class="form-group">
      <input type="password" class="form-control" placeholder="Password" formControlName="password"
        [ngClass]="{'is-invalid': (submitted || f.password.touched) && f.password.errors}" />
      <span class="input-icon"><i class="bi bi-eye-fill"></i></span>
      <div *ngIf="(submitted || f.password.touched) && f.password.errors" class="invalid-feedback">
        <div *ngIf="f.password.errors.required">Password is required</div>
      </div>
    </div>
    <button type="submit" class="btn btn-login w-100 text-white">
      Login <i class="bi bi-box-arrow-in-right"></i>
    </button>
  </form>
</div>
</div>